import React from 'react';
import Lottie from "react-lottie";
import * as contact from "./contactme.json"

function ContactAnimation() {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: contact.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return (
        <div >
        <Lottie options={defaultOptions} height={100} width={250} />
    </div>
    )
}

export default ContactAnimation;
